import {
  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output,
  ViewChild
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  BestPerformingExposure,
  ContentPieChart,
  GaugeCircleChartData,
  InfluencerPost,
  PieChartValue,
  ProgressBar,
  TopExposure,
  ChannelFollowers
} from '../../../../models/influencer';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {Platform} from '../../../../models/platform';
import {Kpi} from '../../../../models/common';
import {CommonConstant, InfluencerTabName, KpiStatus} from '../../../app.constants';
import {MeasureSearchCriteria} from '../../../../models/measure/measure-search-criteria';
import {UserService} from '../../../services/user.service';
import {
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';
import {TranslateService} from '@ngx-translate/core';
import {DateRange} from '../../../../models/date-range';
import {CacheService} from '../../../services/cache/cache.service';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {ObjectUtils} from '../../../utils/object.utils';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {AppSettings} from '../../../utils/app-settings';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';
import {BlockedReason, InvalidAction, WallType} from '../../../../models/user';
import {Subscription} from 'rxjs/Subscription';
import { FollowerGrowth } from '../../../../models/influencer/follower-growth';
import { WebUtils } from '../../../utils/web.utils';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { ChannelInteractionRate } from '../../../../models/influencer/channel-interaction-rate';
import { ChannelFollower } from '../../../../models/influencer/channel-follower';
import { ChannelReach } from '../../../../models/influencer/channel-reach';
import { ChannelInteractionRateDevelopment } from '../../../../models/influencer/channel-interaction-rate-development';
@Component({
  selector: 'influencer-insight',
  templateUrl: './influencer-insight.component.html',
  styleUrls: ['./influencer-insight.component.scss']
})
export class InfluencerInsightComponent implements OnInit, OnDestroy {

  static readonly MAX_SELECTED_ITEM = 4;
  private readonly TOTAL_MODULE = 7; // [IMPORTANT] Todo: update number of modules for visting influencer logic
  @Input() influencerId: number;
  @Input() channelFollowerParams: string;
  @Input() enableInfluencerPlatform: boolean;
  @Output() changeActiveChannel: EventEmitter<any> = new EventEmitter<any>();

  // list all supported platforms
  public platformList: Platform[] = [];
  public topExposures: TopExposure[] = [];
  public isFetchingTopExposures = true;
  public bestPerformingExposures: BestPerformingExposure[] = [];
  public isFetchingbestPerformingExposures = true;
  public influencerActivityLineChartData: Array<object> | null;
  public isFetchingPerformanceTimeline = true;
  public influencerChannelKPIData: Kpi | null;
  public isFetchingKpi = true;
  // global kpi of influencer
  public globalChannelKpi: Kpi | null;
  // active channel
  public influencerChannelList = [];
  public selectedChannelId: number;
  private activeChannel: any;
  private channelSubscription;
  // module loaded counter
  private loadModuleCounterSubject = new BehaviorSubject<number>(0);
  private loadModuleCounterSubscription;
  // show/hide fallback if limit has been reached
  public fallbackMsgTitle = this.translate.instant('INFLUENCER.insight.fallback_title');
  public fallbackMsgContent;
  public showFallback;
  private creditAvailabilitySubscription: Subscription;

  // follower growth
  public followerGrowths: FollowerGrowth[] = [];
  public isFetchingFollowerGrowths = true;

  // interaction rate by channel
  public channelInteractionRates: ChannelInteractionRate[];

  // channel follower
  public channelFollowers: ChannelFollower[];
  public isFetchingChannelFollowers = true;

  // channel reach
  public channelReaches: ChannelReach[];

  // channel reach
  public channelInteractionRateDevelopments: ChannelInteractionRateDevelopment[];
  public isFetchingChannelInteractionRateDevelopments = true;

  @ViewChild('ChannelReachNotificationPopup')
  private _channelReachNotificationPopup: AchooPopupComponent;

  // Error
  public errorMessage: string;
  @ViewChild('ErrorPopup') private _errorPopup: AchooPopupComponent;

  constructor(private influencerService: InfluencerService,
              private pdfExportService: PdfExportService,
              private referenceDataService: ReferenceDataService,
              private eventTracker: EventTrackerService,
              private userService: UserService,
              private cacheService: CacheService,
              private translate: TranslateService,
              private modalService: ModalService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    if (this.influencerService.isCreditAvailable() === true) {
      this.sendViewActionToSegement();
    } else if (this.influencerService.isCreditAvailable() === false) {
      this.sendInvalidViewToSegement();
    }
    this.platformList = this.referenceDataService.platforms;
    if (this.userService.isInfluencer) {
      this.initializeInsightPage(this.influencerId);
    } else {
      this.creditAvailabilitySubscription = this.influencerService.creditAvailabilityObserve.subscribe((res) => {
        if (res === true) {
          this.showFallback = false;
          this.initializeInsightPage(this.influencerId);
        }
        if (res === false) {
          this.fallbackMsgContent = this.translate.instant('INFLUENCER.insight.fallback_msg', {
            maxCredit: this.userService.maxActiveInfluencers
          });
          this.showFallback = true;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.channelSubscription) {
      this.channelSubscription.unsubscribe();
    }
    if (this.loadModuleCounterSubscription) {
      this.loadModuleCounterSubscription.unsubscribe();
    }
    if (this.creditAvailabilitySubscription) {
      this.creditAvailabilitySubscription.unsubscribe();
    }
    this.influencerActivityLineChartData = null;
    this.modalService.close();
  }

  private initializeInsightPage(influencerId) {
    this.loadListChannel(influencerId, this.influencerService.currentActiveChannel)
      .subscribe(activeChannel => {
        this.activeChannel = activeChannel;
        this.selectedChannelId = activeChannel.id;

        // load insight data
        this.processInfluencerDetailByChannel(influencerId, this.activeChannel);

        // observe the loaded module. Whenever all modules are loaded, check if at least one module has available data, if so, track view
        this.loadModuleCounterSubscription = this.loadModuleCounterSubject.asObservable().subscribe((value) => {
          if (value === this.TOTAL_MODULE) {
            if (this.hasInsightData()) {
              // call API mark as visited
              this.markInfluencerAsVisited(influencerId, this.userService.getCompanyId());
            }
          }
        });
        // watching active channel change
        this.channelSubscription = this.influencerService.activeChannel.subscribe((channel) => {
          if (channel && this.isSupportedChannel(channel.id) && (!this.activeChannel || (channel.id !== this.activeChannel.id))) {
            this.activeChannel = channel && channel.id > 0 ? channel : null;
            this.selectedChannelId = channel && channel.id > 0 ? channel.id : null;
            this.processInfluencerDetailByChannel(influencerId, this.activeChannel);
          }
        });
      });
  }

  public onChangeChannel(channel) {
    if (Array.isArray(channel)) {
      return;
    }

    setTimeout(() => {
      this.influencerService.updateActiveChannel(channel);
      this.changeActiveChannel.emit({
        activeTab: InfluencerTabName.INSIGHT,
        channel: channel.id > 0 ? channel.id : null
      });
    }, 200);
  }

  private sendInvalidViewToSegement() {
    const detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.USAGE_LIMIT,
      'Insights Limit', false, null, null, this.userService.accountLevelName);
    this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.VIEW, Page.INFLUENCER_INSIGHTS);
  }

  private sendViewActionToSegement() {
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_INSIGHTS, {
      id: this.influencerService.influencerDetails.id,
      name: this.influencerService.influencerDetails.name,
      type: TargetType.INFLUENCER
    }, undefined, undefined, {
      type: ActivePages.INFLUENCER_INSIGHTS,
      name: this.influencerService.influencerDetails.name,
      id: this.influencerService.influencerDetails.id
    });
  }

  private increaseNumberLoadedModule() {
    const currentValue = this.loadModuleCounterSubject.getValue();
    this.loadModuleCounterSubject.next(currentValue + 1);
  }

  public hasInsightData() {
    if (this.enableInfluencerPlatform) {
      return true;
    }

    // Todo: add check data for feature modules
    return (this.influencerActivityLineChartData && this.influencerActivityLineChartData.length > 0)
      || (this.influencerChannelKPIData && this.influencerChannelKPIData.engagement && this.influencerChannelKPIData.impact && this.influencerChannelKPIData.impressions)
      || (this.topExposures && this.topExposures.length > 0)
      || (this.bestPerformingExposures && this.bestPerformingExposures.length > 0)
      || (this.channelInteractionRates && this.channelInteractionRates.length > 0)
      || (this.followerGrowths && this.followerGrowths.length > 0)
      || (this.channelFollowers && this.channelFollowers.length > 0)
      || (this.channelReaches && this.channelReaches.length > 0)
      || (this.channelInteractionRateDevelopments && this.channelInteractionRateDevelopments.length > 0);
  }

  public canViewInsightData() {
    if (this.userService.isInfluencer) {
      return true;
    }
    return this.influencerService.isCreditAvailable() === true;
  }

  public showFallbackView() {
    if (this.userService.isInfluencer) {
      return false;
    }
    return this.influencerService.isCreditAvailable() === false;
  }

  private markInfluencerAsVisited(influencerId: number, companyId: number) {
    this.influencerService.visitInfluencer(influencerId, companyId).subscribe({
      next: res => {
        if (res === null) {
          return;
        }

        this.userService.triggerUpdateActivatedInfluencers();
      }
    });
  }

  /*
  Load supported channel list and determine selected channel
  */
  private loadListChannel(influencerId, initialChannel): Observable<any> {
    return this.influencerService.fetchListChannel(influencerId).pipe(
      map(res => {
        const supportedChannels = res.filter(c => AppSettings.getActivePlatformList().indexOf(c.platformName.toLowerCase()) >= 0);
        this.influencerChannelList = supportedChannels;

        const hasSelectedChannel = initialChannel && initialChannel.id;

        if (hasSelectedChannel) {
          return initialChannel;
        }

        // pre-select the first channel if initialChannel is not available
        const seletedChannel = supportedChannels[0];
        this.influencerService.updateActiveChannel(seletedChannel);
        this.changeActiveChannel.emit({
          activeTab: InfluencerTabName.INSIGHT,
          channel: seletedChannel.id
        });

        return seletedChannel;
      })
    );
  }

  private isSupportedChannel(channelId) {
    if (!this.influencerChannelList) {
      return false;
    }
    return this.influencerChannelList.findIndex(ic => ic.id === channelId) >= 0;
  }

  private processInfluencerDetailByChannel(influencerId, activeChannel) {
    // calculate KPI and platform reachs of influencer
    this.calculateInfluencerKpiAndPlatformReach(influencerId, activeChannel);
    // load daily kpis data
    this.getDailyKpisByChannel(influencerId, activeChannel);
    // load top exposure posts
    this.getTopExposurePostsByChannel(influencerId, activeChannel);
    // load best performing posts
    this.getBestPerformingPostsByChannel(influencerId, activeChannel);
    // load follower growth
    this.getFollowerGrowth(activeChannel);
    // load channel followers
    this.getInfluencerFollowers(influencerId, this.influencerChannelList);
    // load channel interaction rate development
    this.getChannelInteractionRateDevelopment(activeChannel);
  }

  /**
   * get details of influencer
   * @param influencerId
   * @param activeChannel
   */
  private calculateInfluencerKpiAndPlatformReach(influencerId, activeChannel) {
    this.isFetchingKpi = true;
    this.cacheService.get(`influencer_${influencerId}`, this.influencerService.getInfluencer(influencerId))
      .subscribe((data) => {
        this.increaseNumberLoadedModule();
        this.isFetchingKpi = false;

        if (!data) {
          return;
        }

        this.influencerChannelKPIData = this.influencerService.normalizeChannelAverageKpi(data.channelAverageKpis, data.average, activeChannel);
        this.globalChannelKpi = this.getGlobalKpiByChannel(data.channelGlobalKpis, data.globalKpi, activeChannel);
        this.channelInteractionRates = this.getChannelInteractionRates(data.channelAverageKpis, this.influencerChannelList);
        this.channelReaches = this.getChannelReaches(data.rawChannelGlobalKpis, this.influencerChannelList);
      });
  }

  private getChannelInteractionRates(channelAverageKpis: any[], supportedChannels: any[]): ChannelInteractionRate[] {
    const results: ChannelInteractionRate[] = [];

    if (!Array.isArray(channelAverageKpis) || channelAverageKpis.length === 0) {
      return results;
    }

    let mappedChannelsCount = 0;
    supportedChannels.forEach(channel => {
      const mappedKPI = channelAverageKpis.find(kpi => Number(kpi.channel_id) === channel.id);
      let interactionRate = 0;

      if (mappedKPI) {
        interactionRate = (mappedKPI.engagement_rate_avg === undefined || mappedKPI.engagement_rate_avg === null)
          ? 0
          : mappedKPI.engagement_rate_avg * 100;
        mappedChannelsCount++;
      }

      results.push({
        channelId: channel.id,
        channelName: channel.name,
        platformId: channel.platformId,
        platformName: channel.platformName,
        interactionRate
      });
    });

    // No data for all channels
    if (mappedChannelsCount === 0) {
      return [];
    }

    return results;
  }

  private getChannelReaches(rawChannelGlobalKpis: any[], supportedChannels: any[]): ChannelReach[] {
    const results: ChannelReach[] = [];

    if (!Array.isArray(rawChannelGlobalKpis) || rawChannelGlobalKpis.length === 0) {
      return results;
    }

    let reachSum = 0;
    let mappedChannelsCount = 0;

    supportedChannels.forEach(channel => {
      const mappedKPI = rawChannelGlobalKpis.find(kpi => Number(kpi.channel_id) === channel.id);

      if (mappedKPI) {
        results.push({
          channelId: channel.id,
          channelName: channel.name,
          platformName: channel.platformName,
          reach: mappedKPI.reach,
          reachChangePercentage: mappedKPI.reach_change * 100
        });
        reachSum += mappedKPI.reach;
        mappedChannelsCount++;
      } else {
        results.push({
          channelId: channel.id,
          channelName: channel.name,
          platformName: channel.platformName,
          reach: 0,
          reachChangePercentage: 0
        });
      }
    });

    // No data for all channels
    if (mappedChannelsCount === 0) {
      return [];
    }

    results.forEach(r => r.reachPercentage = r.reach / reachSum * 100);

    return results;
  }

  public onChannelReachMaxChannelSelectionExceeded() {
    this.modalService.close();
    this.modalService.open(this._channelReachNotificationPopup, null, true);
  }

  /**
   * fetch top exposure posts of influencer by channel
   * @param influencerId
   * @param activeChannel
   */
  private getTopExposurePostsByChannel(influencerId, activeChannel) {
    this.isFetchingTopExposures = true;
    this.topExposures = [];
    let topExposureParams = {
      period: CommonConstant.PERIOD_30_DAYS
    };
    let cachingKey = `influencer_top_exposures_${influencerId}`;
    if (activeChannel) {
      topExposureParams = Object.assign({}, topExposureParams, {
        channelId: activeChannel.id
      });
      cachingKey = `channel_top_exposures_${activeChannel.id}`;
    }
    this.cacheService.get(cachingKey, this.influencerService.getTopExposures(influencerId, topExposureParams))
      .subscribe((res: any) => {
        this.increaseNumberLoadedModule();
        this.isFetchingTopExposures = false;
        if (!res) {
          return;
        }
        this.topExposures = this.formatTopExposureData(res);
      }, (err) => {
        this.topExposures = [];
        this.increaseNumberLoadedModule();
        this.isFetchingTopExposures = false;
      });
  }

  private formatTopExposureData(data) {
    if (data.reach.influencer_id || data.engagement.influencer_id || data.impact.influencer_id) {
      return [data.reach, data.engagement, data.impact];
    }
    return [];
  }

  /**
   * fetch daily kpi data of influencer by channel
   * @param influencerId
   * @param activeChannel
   */
  private getDailyKpisByChannel(influencerId, activeChannel) {
    this.isFetchingPerformanceTimeline = true;
    let performanceTimelineParams = {
      period: CommonConstant.PERIOD_30_DAYS
    };
    let cachingKey = `influencer_daily_kpis_${influencerId}`;
    if (this.enableInfluencerPlatform) {
      performanceTimelineParams = Object.assign({}, performanceTimelineParams, {
        period: CommonConstant.PERIOD_7_DAYS
      });
    }
    if (activeChannel) {
      performanceTimelineParams = Object.assign({}, performanceTimelineParams, {
        channelId: activeChannel.id
      });
      cachingKey = `channel_daily_kpis_${activeChannel.id}`;
    }
    this.cacheService.get(cachingKey,
      this.influencerService.getDailyKpiTimeLineChart(influencerId, performanceTimelineParams))
      .subscribe((res: any) => {
        this.isFetchingPerformanceTimeline = false;
        this.influencerActivityLineChartData = ObjectUtils.deepClone(res);
        this.increaseNumberLoadedModule();
      });
  }

  /**
   * fetch best performing posts in 30 days of influencer based on channel
   * @param influencerId
   * @param activeChannel
   */
  private getBestPerformingPostsByChannel(influencerId, activeChannel) {
    this.isFetchingbestPerformingExposures = true;
    this.bestPerformingExposures = [];
    let bestPerformingParams = {
      period: CommonConstant.PERIOD_30_DAYS,
      limit: CommonConstant.LIMIT_20
    };
    let cachingKey = `influencer_best_performing_${influencerId}`;
    if (activeChannel) {
      bestPerformingParams = Object.assign({}, bestPerformingParams, {
        channelId: activeChannel.id
      });
      cachingKey = `channel_best_performing_${activeChannel.id}`;
    }
    this.cacheService.get(cachingKey, this.influencerService.getBestPerforming(influencerId, bestPerformingParams))
      .subscribe({
        next: res => {
          this.bestPerformingExposures = res;
          this.increaseNumberLoadedModule();
          this.isFetchingbestPerformingExposures = false;
        },
        error: error => {
          this.increaseNumberLoadedModule();
          this.isFetchingbestPerformingExposures = false;
          WebUtils.reportErrorToSentry('Load influencer best performing posts fails', error);
          this.showError(this.translate.instant('INFLUENCER.insight.best_performing_posts.load_error_message'));
        }
      });
  }

  private getGlobalKpiByChannel(channelGlobalKpis: any[], globalKpi: any, activeChannel: any) {
    if (!Array.isArray(channelGlobalKpis) || channelGlobalKpis.length === 0) {
      return null;
    }
    if (activeChannel) {
      return channelGlobalKpis.find(gk => gk.channelId === activeChannel.id);
    }
    return globalKpi;

  }

  private getInfluencerFollowers(influencerId: number, supportedChannels: any[]) {
    this.isFetchingChannelFollowers = true;
    this.channelFollowers = [];
    const cachingKey = `influencer_followers_${influencerId}`;

    this.cacheService.get(cachingKey, this.influencerService.getInfluencerFollowers(influencerId))
      .subscribe({
        next: data => {
          this.increaseNumberLoadedModule();
          this.isFetchingChannelFollowers = false;

          if (data) {
            const channelFollowers: ChannelFollower[] = [];
            const channels = data.channels;

            if (channels.length === 0) {
              this.channelFollowers = [];
              return;
            }

            let mappedChannelsCount = 0;
            supportedChannels.forEach(channel => {
              const mappedChannelFollower = channels.find(x => x.channelId === channel.id);
              let followerCount = 0;

              if (mappedChannelFollower) {
                followerCount = mappedChannelFollower.followerCount;
                mappedChannelsCount++;
              }

              channelFollowers.push({
                channelId: channel.id,
                channelName: channel.name,
                platformName: channel.platformName,
                followerCount
              });
            });

            // No data for all channels
            if (mappedChannelsCount === 0) {
              this.channelFollowers = [];
              return;
            }

            this.channelFollowers = channelFollowers;
          }
        },
        error: error => {
          this.increaseNumberLoadedModule();
          this.isFetchingChannelFollowers = false;
          WebUtils.reportErrorToSentry('Load channel followers fails', error);
          this.showError(this.translate.instant('INFLUENCER.insight.follower_by_channel.load_error_message'));
        }
      });
  }

  private getFollowerGrowth(activeChannel) {
    this.followerGrowths = [];
    this.isFetchingFollowerGrowths = true;
    const channelId = activeChannel && activeChannel.id;

    this.influencerService.getFollowerGrowth(channelId)
      .subscribe({
        next: followerGrowths => {
          this.followerGrowths = followerGrowths;
          this.increaseNumberLoadedModule();
          this.isFetchingFollowerGrowths = false;
        },
        error: error => {
          this.increaseNumberLoadedModule();
          this.isFetchingFollowerGrowths = false;
          WebUtils.reportErrorToSentry('Load influencer follower growth fails', error);
          this.showError(this.translate.instant('INFLUENCER.insight.follower_growth.load_error_message'));
        }
      });
  }

  private getChannelInteractionRateDevelopment(activeChannel) {
    this.channelInteractionRateDevelopments = [];
    this.isFetchingChannelInteractionRateDevelopments = true;
    const channelId = activeChannel && activeChannel.id;
    const cachingKey = `channel_interaction_rate_development_${channelId}`;

    this.cacheService.get(cachingKey, this.influencerService.getChannelInteractionRateDevelopment(channelId))
      .subscribe({
        next: channelInteractionRateDevelopments => {
          this.channelInteractionRateDevelopments = channelInteractionRateDevelopments;
          this.increaseNumberLoadedModule();
          this.isFetchingChannelInteractionRateDevelopments = false;
        },
        error: error => {
          this.increaseNumberLoadedModule();
          this.isFetchingChannelInteractionRateDevelopments = false;
          WebUtils.reportErrorToSentry('Load channel interaction rate development fails', error);
          this.showError(this.translate.instant('INFLUENCER.insight.interaction_rate_development.load_error_message'));
        }
      });
  }

  private showError(message): void {
    this.modalService.close();
    this.errorMessage = message;
    this.modalService.open(this._errorPopup, null, true);
  }

  get lineChartTitle() {
    return this.enableInfluencerPlatform ? this.translate.instant('INFLUENCER.insight.activity_chart.ip_title')
      : this.translate.instant('INFLUENCER.insight.activity_chart.title');
  }

  get isExportingPdf() {
    return this.pdfExportService.exportingPdf;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-insight.component.ts